import React, { createContext, useContext, useState, useEffect } from "react";
import { useAccount, useChainId, useSwitchChain } from "wagmi";

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const wallet  = useAccount(); // Get connected wallet & chain
  const chain = useChainId()
  const { chains, switchChain } = useSwitchChain()
  const [selectedChain, setSelectedChain] = useState(chain || 8523);

  useEffect(() => {
    if (chain) {
      setSelectedChain(chain);
    }
  }, [chain]);

  const changeNetwork = async (chain) => {
    if (!chain) {
      console.error("Invalid chain ID:", chain);
      return;
    }

    
    try {
      await switchChain({chainId:chain?.id});
      setSelectedChain(chain?.id);
    } catch (error) {
      console.error("Failed to switch network", error);
    }
  };

  return (
    <WalletContext.Provider value={{ wallet, selectedChain, changeNetwork }}>
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => useContext(WalletContext);
